import React from 'react';
import PageEnvelope from '../elements/PageEnvelope';
import './HomePage.css';

interface HomePageState {
}

class HomePage extends React.Component<{}, HomePageState> {
  constructor(props:{}) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
  }

  render() {
    let width = '750px';
    let padding = '40px';

    return(
      <div className="site-page">
        <PageEnvelope color="var(--header-background-color)" width={width} padding={padding}>
          <div className="home-page-create-community">
            <div className="site-page-column" style={{color: 'white', rowGap: '15px'}}>
              <div>
                <div style={{fontSize: '1.4em', fontWeight: 'bolder'}}>CREATE YOUR OWN</div>
                <div style={{color: 'var(--button-background-color)', fontSize: '1.4em', fontWeight: 'bolder'}}>INSTANT COMMUNITY</div>
              </div>
              <div>
                Starting your own custom community is easier than ever with OneClick.Community.
              </div>    
              <div style={{marginTop: '10px'}}>
                <button style={{color: 'var(--header-background-color)', backgroundColor: 'white'}}>Get Started</button>
              </div>         
            </div>
            <div>
              <div style={{display: 'flex', justifyContent: 'right'}}>
                <img src="/landing/circles.png" style={{width: '230px'}} />
              </div>
            </div>
          </div>
        </PageEnvelope>
        <PageEnvelope color="white" width={width} padding={padding}>
          <div className="site-page-column" style={{textAlign: 'center'}}>
            <div style={{fontSize: '1.4em', fontWeight: 'bolder'}}>COMMUNITY IS THE <span style={{color: '#BC6230'}}>NEW CURRENCY</span></div>
            <div>Today, community is more important than ever.  We're here to help you build a strong, vibrant community that can unlock new opportunities.</div>
            <div style={{marginTop: '10px'}}>
              <button>See Features</button>
            </div>         
          </div>
        </PageEnvelope>
        <PageEnvelope color="var(--button-background-color)" width={width} padding={padding}>
          <div className="home-page-create-community">
            <div className="site-page-column" style={{color: 'white', rowGap: '15px'}}>
              <div style={{fontSize: '1.4em', fontWeight: 'bolder'}}>OWN YOUR DATA</div>
              <div>Don’t build your community on a platform that can change the rules or algorithm at any moment.  With a One Click Community, you own it all, and you aren’t giving your information to data slurping, surveillance capital platforms.</div>    
              <div style={{marginTop: '10px'}}>
                <button style={{color: 'var(--button-background-color)', backgroundColor: 'white'}}>Learn More</button>
              </div>         
            </div>
            <div>
              <div style={{display: 'flex', justifyContent: 'right'}}>
                <img src="/landing/computer.png" style={{width: '250px'}} />
              </div>
            </div>
          </div>
        </PageEnvelope>
        <PageEnvelope color="var(--header-background-color)" width={width}>
          <div style={{color: '#ffffff80', textAlign: 'center', fontSize: '0.9em'}}>© 2003 Monster Ideas LLC</div>
        </PageEnvelope>
      </div>
    )
  }
}

export default HomePage;